export const CLI_AUTH_SESSION_KEY = 'cliAuthSessionId'
export const SESSION_ID_REGEX = /^[0-9a-f]{64}$/i

export function isValidSessionId(sessionId) {
  return typeof sessionId === 'string' && SESSION_ID_REGEX.test(sessionId)
}

export function getSessionIdFromUrl() {
  const params = new URLSearchParams(window.location.search)
  return params.get('sessionId') || null
}

export function storeSessionId(sessionId) {
  if (isValidSessionId(sessionId)) {
    localStorage.setItem(CLI_AUTH_SESSION_KEY, sessionId)
  }
}

export function getStoredSessionId() {
  return localStorage.getItem(CLI_AUTH_SESSION_KEY)
}

export function clearStoredSessionId() {
  localStorage.removeItem(CLI_AUTH_SESSION_KEY)
}
